import { theme } from '@bottlebooks/gatsby-design-system';
export default Object.assign(Object.assign({}, theme.zIndices), { modal: 2000 });
//# sourceMappingURL=zIndices.js.map